import {Sex, SexValues} from "../api/generated/herd-animal";
import {Female, Male} from "@mui/icons-material";
import React from "react";

export const SexIcon = ({sex, color}: { sex: Sex, color?: string }) => {
    switch (sex) {
        case SexValues.MALE:
            return <Male titleAccess="Hengst" htmlColor={color}/>;
        case SexValues.FEMALE:
            return <Female titleAccess="Stute" htmlColor={color}/>;
        default:
            return null;
    }
};

